import styled from 'styled-components';

const RecipientName = styled.div``;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const Head = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 948px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentHeadArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const HeadTitleArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export { Content, ContentHeadArea, Head, HeadTitleArea, RecipientName, Wrapper };
